module.exports = __webpack_public_path__ + "img/medio_1.61972a37.webp";